<div class="r-box-body data-table mg-t30 mg-b30">
    <div class="r-box-header ">
        <div class="font-weight-bold mg-b30">
            <div class="d-flex">
                <input type="search" (search)="search($event)" class="search" placeholder="Search by name or email" />
                <div class="filter-holder" ngbDropdown>
                    <button type="button" class="btn filter-button" display="bottom-left" id="gfg" ngbDropdownToggle>
                        <i class="fa fa-cog" aria-hidden="true"></i>
                    </button>
                    <div ngbDropdownMenu="gfg">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">

                                <div class="modal-body">
                                    <div class="switch-holder" *ngIf="showPrePostFilter">
                                        <p class="regular-text">Pre & Post</p>
                                        <div class="switch">
                                            <input type="checkbox" id="toggle-button-checkbox-2" [checked]="includeAssessments"
                                                (click)="toggleSwitch($event.target.checked, 'assessments')">
                                            <label class="toggle-button-switch2" for="toggle-button-checkbox-2"></label>
                                            <div class="toggle-button-text">
                                                <div class="toggle-button-text-on">ON</div>
                                                <div class="toggle-button-text-off">OFF</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="switch-holder" *ngIf="showMasterclassFilter">
                                        <p class="regular-text">Live Sessions</p>
                                        <div class="switch">
                                            <input type="checkbox" id="toggle-button-checkbox" [checked]="includeMasterclasses"
                                                (click)="toggleSwitch($event.target.checked, 'masterclass')">
                                            <label class="toggle-button-switch" for="toggle-button-checkbox"></label>
                                            <div class="toggle-button-text">
                                                <div class="toggle-button-text-on">ON</div>
                                                <div class="toggle-button-text-off">OFF</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="switch-holder" *ngIf="showCourseFilter">
                                        <p class="regular-text">Courses</p>
                                        <div class="switch">
                                            <input type="checkbox" id="toggle-button-checkbox-1" [checked]="includeCourses"
                                                (click)="toggleSwitch($event.target.checked, 'course')">
                                            <label class="toggle-button-switch1" for="toggle-button-checkbox-1"></label>
                                            <div class="toggle-button-text">
                                                <div class="toggle-button-text-on">ON</div>
                                                <div class="toggle-button-text-off">OFF</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="switch-holder" *ngIf="showAssessmentFilter">
                                        <p class="regular-text">Thrive Drills</p>
                                        <div class="switch">
                                            <input type="checkbox" id="toggle-button-checkbox-3" [checked]="includeThriveDrills"
                                                (click)="toggleSwitch($event.target.checked, 'thrive drill')">
                                            <label class="toggle-button-switch3" for="toggle-button-checkbox-3"></label>
                                            <div class="toggle-button-text">
                                                <div class="toggle-button-text-on">ON</div>
                                                <div class="toggle-button-text-off">OFF</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-sort">
                <div ngbDropdown class="">
                    <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
                        {{selectedValue ? selectedValue : 'Sort'}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-down-values">
                        <button *ngFor="let option of dropDownData" ngbDropdownItem
                            (click)="onSortChange(option.value, option.name)">{{option.name}}</button>

                    </div>
                </div>

            </div>
        </div>

    </div>
    <div class="r-box-body scrollable table-responsive w-100">
        <table class="table mg-r10">
            <!-- <thead class="font-16"> -->
            <tr class="course-names">
                <ng-container *ngFor="let col of  progColumns" >
                <th class="font-16" [ngClass]="col.type" [attr.colspan]="col.span"
                    *ngIf="col.type === 'COURSE' ? includeCourses : col.type === 'MASTERCLASS' ? includeMasterclasses : col.type === 'PRE' || col.type === 'POST' ? includeAssessments : col.type === 'ASSESSMENT' ? includeThriveDrills : true"
                    >
                    <p>
                        <!-- <span class="pill" *ngIf="col.title !== ''">{{col.type.toLowerCase()}}</span> -->
                        <span class="pill card-header white" *ngIf="col.type === 'MASTERCLASS'">
                            {{col.title.toLowerCase().includes('thrive live') ? 'Thrive Live' : col.type.toLowerCase()}}
                        </span>
                        <span class="pill card-header grey" *ngIf="col.type === 'COURSE'">
                            {{col.title.toLowerCase().includes('thrive master') ? 'Thrive Master' : col.type.toLowerCase()}}
                        </span>
                        <span class="pill card-header grey" *ngIf="col.type === 'PRE' || col.type === 'POST'">
                            {{col.type.toLowerCase()}}
                        </span>
                        <span class="pill card-header grey" *ngIf="col.type === 'ASSESSMENT'">
                            {{col.title.toLowerCase().includes('thrive drill') ? 'Thrive Drill' : col.type.toLowerCase()}}
                        </span>
                        <span class="title-name">{{col.title.toLowerCase()}}</span>
                    </p>
                </th>
                </ng-container>
            </tr>
            <tr class="course-headers">
                <ng-container *ngFor="let col of  headerColumns" >
                <th class="column-name" [ngClass]="[col.type + col.origType]"
                *ngIf="col.origType === 'COURSE' ? includeCourses : col.origType === 'MASTERCLASS' ? includeMasterclasses : col.origType === 'PRE' || col.origType === 'POST' ? includeAssessments : col.origType === 'ASSESSMENT' ? includeThriveDrills : true"

                >
                    {{col.title}}</th>
                </ng-container>
            </tr>
            <tbody>
                <tr
                    *ngFor="let learner of filteredLearners | paginate: {itemsPerPage: 10, currentPage:page, id: '1'}; let i = index;">
                    <ng-container *ngFor="let col of learner; let j = index">
                    <td
                         *ngIf="headerColumns[j].origType === 'COURSE' ? includeCourses : headerColumns[j].origType === 'MASTERCLASS' ? includeMasterclasses : headerColumns[j].origType === 'PRE' || headerColumns[j].origType === 'POST' ? includeAssessments : headerColumns[j].origType === 'ASSESSMENT' ? includeThriveDrills : true"

                        [ngClass]="[headerColumns[j].type === 'item_review' ? 'review_width' : '', headerColumns[j].type+headerColumns[j].origType]">
                        <span class='pill' *ngIf="headerColumns[j].type == 'score'">{{col >= 0 ? col : 'NA'}}</span>
                        <app-progress-bar class="pd-t10" *ngIf="headerColumns[j].type == 'progress'"
                            colorValue="success" maxValue="100" [progressValue]="col" showTitle="true">
                        </app-progress-bar>
                        <span *ngIf="headerColumns[j].type === 'item_review'">
                            <p *ngIf="hideme[i]; else elseBlock">{{col !== null ? col : '-'}}</p>
                            <ng-template #elseBlock>{{col !== null && col?.length > 20 ? (col | slice:0:20)+'...' : col}}
                            </ng-template>
                            <p *ngIf="col == null">-</p>
                            <button *ngIf="col !== null && col?.length > 20" type="button" class="viewmore"
                                (click)="hideme[i] = !hideme[i]">{{hideme[i] ? 'Read Less' : 'Read More'}}</button>
                        </span>
                        <!-- <button type="button" class="viewless" *ngIf="readMore" (click)="readMore=false">Read Less</button> -->
                        <span
                            *ngIf="headerColumns[j].type !== 'score' && headerColumns[j].type !== 'progress' && headerColumns[j].type !== 'item_review'"
                            [ngClass]="[col === 'Completed' ? 'text-green' : '', col === 'Not Started' ? 'text-red' : '', col === 'Ongoing' ? 'text-blue' : '']">{{col
                            === 'NA' ? '-' : col}}</span>
                    </td>
                </ng-container>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="row table-button pd-l10 mg-t20">
        <div class="col-lg-5 col-md-5 col-sm-4 col-6">
            <button class="font-12 cursor-pointer" (click)="downloadReport()">Download Report</button>
        </div>
        <div class="col-lg-7 col-md-7 col-sm-8 col-6">
            <app-table-pagination (pageChange)="page = $event" id="1" maxSize="10" directionLinks="true" autoHide="true"
                [totalListCount]="learners ? learners.length : 0"></app-table-pagination>
        </div>
    </div>
</div>

<!--
<div class="r-box">
    <div class="r-box-body col-sm-12">
        <div class="col-sm-3 counter ">
            <p class="counter-title">Profile</p>
            <p><span class="counter-number">Product Design</span></p>
        </div>
        <div class="col-sm-3 counter">
            <p class="counter-title">Dipartment</p>
            <p><span class="counter-number">Creative Studio</span></p>
        </div>
        <div class="col-sm-3 counter">
            <p class="counter-title">Manager</p>
            <p><span class="counter-number">Anurag Sharma</span></p>
        </div>
        <div class="col-sm-3 counter">
            <p class="counter-title">User Group</p>
            <p><span class="counter-number">5th</span></p>
        </div>
    </div>
</div>

<div class="summary row">
    <div class="col-lg-2 col-md-4 col-sm-12 col-2">
        <div class="r-box">
            <div class="r-box-header">
                Rank
            </div>
            <div class="r-box-body">
                <div class="counter mg-r20 pd-r20">
                    <p class="counter-title">Score</p>
                    <p><span class="counter-number">2</span>
                        <span class="counter-unit">nd</span>
                    </p>
                </div>
                <div class="counter">
                    <p class="counter-title">Engagement</p>
                    <p><span class="counter-number">3</span>
                        <span class="counter-unit">nd</span>
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-md-4 col-sm-12 col-5">
        <div class="r-box">
            <div class="r-box-header pd-l15 pd-b20">
                Program Completion
            </div>
            <div class="r-box-body pd-l15 progress-value">
                <div class="d-flex pd-b15">
                    <p>Learner</p>
                    <app-progress-bar class="col-8" progressHeight="20px" unitValue="block" displayPosition="right" maxValue="65" progressValue="40" colorValue="success" showTitle="true"></app-progress-bar>
                </div>
                <div class="d-flex">
                    <p>Cohort</p>
                    <app-progress-bar class="col-8" progressHeight="20px" unitValue="block" displayPosition="right" maxValue="65" progressValue="65" colorValue="0099DF" showTitle="true"></app-progress-bar>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-5 col-md-4 col-sm-12 col-5">
        <div class="r-box ">
            <div class="r-box-header pd-l15 pd-b20">
                Weekly Learning Hours
            </div>
            <div class="r-box-body pd-l15 progress-value">
                <div class="d-flex pd-b15">
                    <p>Learner</p>
                    <app-progress-bar class="col-8" progressHeight="20px" displayPosition="right" maxValue="50" progressValue="35.5" colorValue="success" showTitle="true"></app-progress-bar>
                </div>
                <div class="d-flex">
                    <p>Cohort</p>
                    <app-progress-bar class="col-8" progressHeight="20px" displayPosition="right" maxValue="50" progressValue="45.5" colorValue="0099DF" showTitle="true"></app-progress-bar>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="summary row mg-b50">
    <div class="col-4 col-lg-4 col-md-4 col-sm-12">
        <div class="r-box">
            <div class="r-box-header">
                Goals From The Program
            </div>
            <div class="r-box-body pd-l20 pd-r20">
                <ul>
                    <li>
                        Enable a culture of collabration and smart decision making.
                    </li>
                    <li>
                        Create standard of excellence in managing project, problem solving and quality.
                    </li>
                    <li>
                        Reduce confusion and conflict within teams where managers and individual are selfaware and
                            foster trust...<a class="success">Read More</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-4 col-lg-4 col-md-4 col-sm-12">
        <div class="r-box">
            <div class="r-box-header">
                Expectations
            </div>
            <div class="r-box-body pd-l20 pd-r20">
                <ul>
                    <li>
                        Enable a culture of collabration and smart decision making.
                    </li>
                    <li>
                        Create standard of excellence in managing project, problem solving and quality.
                    </li>
                    <li>
                        Reduce confusion and conflict within teams where managers and individual are selfaware and
                            foster trust...<a class="success">Read More</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-4 col-lg-4 col-md-4 col-sm-12">
        <div class="r-box ">
            <div class="r-box-header">
                Challenges
            </div>
            <div class="r-box-body pd-l20 pd-r20">
                <ul>
                    <li>
                        Enable a culture of collabration and smart decision making.
                    </li>
                    <li>
                        Create standard of excellence in managing project, problem solving and quality.
                    </li>
                    <li>
                        Reduce confusion and conflict within teams where managers and individual are selfaware and
                            foster trust...<a class="success">Read More</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="program-summary">
    <div class="r-box-body data-table mg-b70">
        <div class="r-box-header ">
            <div class="text-center mg-b50 w-100">
                <h1>Program Summary</h1>
            </div>
        </div>
        <div class="r-box-body scrollable">
            <table class="table table-responsive">
                <thead>
                    <th>Program Name</th>
                    <th>Completion Status</th>
                    <th>Day Since Available</th>
                    <th>Score</th>
                    <th>Average Cohort's Score</th>
                    <th style="width: 30%">Rating &  Review by Learner</th>
                </thead>
                <tbody  class="mg-t20">
                    <tr *ngFor="let leader of ProgramSummarys">
                        <td>{{leader.ProgramName}}</td>
                        <td class="completion-status pd-r30">
                            <app-progress-bar unitValue="block" displayPosition="right" colorValue="success"  maxValue="100" [progressValue]="leader.CompletionStatus1" showTitle="true"></app-progress-bar>
                            <span></span>
                            <app-progress-bar unitValue="block" displayPosition="right" colorValue="0099DF"  maxValue="100" [progressValue]="leader.CompletionStatus2" showTitle="true"></app-progress-bar>
                        </td>
                        <td>{{leader.DaysSinceAvailable}}</td>
                        <td class="pill">{{leader.Score != null? leader.Score : 'NA'}}</td>
                        <td>{{leader.AvailableCohortsScore != null? leader.AvailableCohortsScore : 'NA'}}</td>
                        <td>
                            <span class="table-rating">
                                <app-star-rating [starSize]="1.6" [starRating]='leader.Rating'></app-star-rating>
                            </span>
                            <span class="description">
                                {{(leader.readMore) ? leader.Review : leader.Review | slice:0:100}} <span *ngIf="!leader.readMore">...</span>
                                <a href="javascript:;" *ngIf="!leader.readMore" (click)="leader.readMore=true">Read More</a>
                                <a href="javascript:;" *ngIf="leader.readMore" (click)="leader.readMore=false">Read Less</a>
                            </span>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="r-box-body pd-l30">
            <div class="status">
                <div class="mg-r20"><span class="dot green"></span>Completed</div>
                <div class="mg-r20"><span class="dot blue"></span>Ongoing</div>
            </div>
        </div>
    </div>
</div>

<div class="self-assement mg-b50">
    <div class="r-box-header ">
        <div class="text-center mg-b30 w-100">
            <h1>Self Assesment by the learner</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-4 col-lg-4 col-md-4 col-sm-12">
            <div class="r-box pd-b30">
                <div class="r-box-header">
                    Highest Rated skill
                </div>
                <p>Skills that loved by the Learners</p>
                <div class="r-box-body">
                        <p class="pd-t15">Skill - 1<span class="float-right">4.3 / 5</span></p>
                        <app-progress-bar maxValue="5" progressValue="4.3" colorValue="warning" showTitle="false"></app-progress-bar>
                        <p class="pd-t15">Skill - 5<span class="float-right">4.3 / 5</span></p>
                        <app-progress-bar maxValue="5" progressValue="4.3" colorValue="warning" showTitle="false"></app-progress-bar>
                        <p class="pd-t15">Skill - 7<span class="float-right">4.3 / 5</span></p>
                        <app-progress-bar maxValue="5" progressValue="4.3" colorValue="warning" showTitle="false"></app-progress-bar>
                </div>
            </div>
        </div>
        <div class="col-4 col-lg-4 col-md-4 col-sm-12">
            <div class="r-box pd-b30">
                <div class="r-box-header">
                    Lowest Rated skill
                </div>
                <p>Skills that are not adored by the Learners</p>
                <div class="r-box-body">
                    <p class="pd-t15">Skill - 2<span class="float-right">2.3 / 5</span></p>
                    <app-progress-bar maxValue="5" progressValue="2.3" colorValue="warning" showTitle="false"></app-progress-bar>
                    <p class="pd-t15">Skill - 6<span class="float-right">3.1 / 5</span></p>
                    <app-progress-bar maxValue="5" progressValue="3.1" colorValue="warning" showTitle="false"></app-progress-bar>
                    <p class="pd-t15">Skill - 3<span class="float-right">2.1 / 5</span></p>
                    <app-progress-bar maxValue="5" progressValue="2.1" colorValue="warning" showTitle="false"></app-progress-bar>
                </div>
            </div>
        </div>
        <div class="col-4 col-lg-4 col-md-4 col-sm-12">
            <div class="r-box pd-b30">
                <div class="r-box-header">
                    Skills with Maximum shift
                </div>
                <p>Learners reported maximum shift at the end.</p>
                <div class="r-box-body">

                        <p class="pd-t15">Skill - 4<span class="float-right">3.9 > 4.5 / 5</span></p>
                        <div class="progress">
                            <div class="progress-bar bg-success border-rounded-pill" style="width: 78%;">

                            </div>
                            <div class="progress-bar bg-warning border-rounded-pill" style="width: 12%;">

                            </div>
                        </div>

                        <p class="pd-t15">Skill - 8<span class="float-right">3.2 > 4.0 / 5</span></p>
                        <div class="progress">
                            <div class="progress-bar bg-success" style="width: 64%;">

                            </div>
                            <div class="progress-bar bg-warning" style="width: 16%;">

                            </div>
                        </div>

                        <p class="pd-t15">Skill - 9<span class="float-right">3.7 > 4.3 / 5</span></p>
                        <div class="progress">
                            <div class="progress-bar bg-success" style="width: 35%;">

                            </div>
                            <div class="progress-bar bg-warning" style="width: 6%;">

                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>

</div>

<div class="action-history">
    <div class="r-box-header ">
        <div class="text-center mg-b30 w-100">
            <h1>Action History</h1>
        </div>
    </div>
    <div class="row">
        <div class="col-6 col-lg-6 col-md-6 col-sm-12">
            <div class="r-box">
                <div class="r-box-header">
                    Nudge History
                </div>
                <div class="r-box-body">
                    <div class="">
                        <ul class="pd-l20 pd-r20">
                            <li>12th September 2022</li>
                            <li>12th September 2022</li>
                            <li>22th September 2022</li>
                            <li>22th September 2022</li>
                        </ul>
                        <button class="blue">
                            <i class="fa fa-bell"></i> Nudge
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 col-lg-6 col-md-6 col-sm-12">
            <div class="r-box">
                <div class="r-box-header">
                    Recognition History
                </div>
                <div class="r-box-body">
                    <div class="">
                        <ul class="pd-l20 pd-r20">
                            <li>12th September 2022</li>
                            <li>12th September 2022</li>
                            <li>22th September 2022</li>
                            <li>22th September 2022</li>
                        </ul>
                        <button class="green">
                            <i class="fa fa-certificate"></i> Recognize
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
